import * as z from 'zod/mini';
import { optional } from '@/utility/zodHelpers';

const integer = z.coerce.number().check(z.minimum(1), z.multipleOf(1));

export const serverAssortmentDetailParamsSchema = z.object({
  appearance: optional(integer),
});

export type ServerAssortmentDetailSearchParams = z.infer<typeof serverAssortmentDetailParamsSchema>;

export const assortmentDetailParamsSchema = z.optional(
  z.object({
    appearance: optional(integer),
    quantity: optional(integer),
    views: optional(
      z.pipe(
        z.string(),
        z.transform((val) => val.split(',').map(String))
      )
    ),
    embroidery: optional(
      z.pipe(
        z.string(),
        z.transform((val) => String(val).toLowerCase() === 'true')
      )
    ),
  })
);

export type AssortmentDetailSearchParams = z.infer<typeof assortmentDetailParamsSchema>;
